"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATE_POINTS_AND_FEES_LIEN_POSITION_RESTRICTIONS = exports.DEFAULT_FEDERAL_POINTS_AND_FEES_THRESHOLD_LIMIT = exports.FEDERAL_POINTS_AND_FEES_THRESHOLD_LIMIT_BY_YEAR = exports.STATE_POINTS_AND_FEES_THRESHOLD_LIMITS_BY_YEAR = void 0;
// Master HCM spreadsheet: https://www.google.com/url?q=https://docs.google.com/spreadsheets/d/1cjC7TAlZ1vQB3VgrD-FSLbjxj15pnGLqBmdtdaog4Wc/edit?gid%3D0%23gid%3D0&sa=D&source=editors&ust=1751061313300025&usg=AOvVaw2iPXFvIiCWSH0UexeqOHk_
/**  @TranslateToPython  */
exports.STATE_POINTS_AND_FEES_THRESHOLD_LIMITS_BY_YEAR = {
    '2025': {
        AR: 0.05,
        CO: 0.05,
        DC: 0.05,
        GA: 0.05,
        IL: 0.05,
        MA: 0.05,
        ME: 0.05,
        MD: 0.04,
        NJ: 0.045,
        NM: 0.05,
        NY: 0.05,
        NC: 0.05,
        OH: 0.05,
        RI: 0.05,
        VT: 0.04,
    },
    '2026': {
        AR: 0.05,
        CO: 0.05,
        DC: 0.05,
        GA: 0.05,
        IL: 0.05,
        MA: 0.05,
        ME: 0.05,
        MD: 0.04,
        NJ: 0.045,
        NM: 0.05,
        NY: 0.05,
        NC: 0.05,
        OH: 0.05,
        RI: 0.05,
        VT: 0.04,
    },
};
/**
 * Federal rules:
 * - Loans $20,000 or more: 5% of total loan amount
 * - Loans under $20,000: 8% of total loan amount or $1,000 (whichever is less)
 * Take conservative approach and set to 5%
 * Update these values yearly
 */
/**  @TranslateToPython  */
exports.FEDERAL_POINTS_AND_FEES_THRESHOLD_LIMIT_BY_YEAR = {
    '2025': 0.05,
    '2026': 0.05,
};
/**
 * Fall back in case we haven't updated the federal limit for a given year
 */
/**  @TranslateToPython  */
exports.DEFAULT_FEDERAL_POINTS_AND_FEES_THRESHOLD_LIMIT = 0.05;
/**
 * States where fee restrictions only apply to certain lien positions
 */
/**  @TranslateToPython  */
exports.STATE_POINTS_AND_FEES_LIEN_POSITION_RESTRICTIONS = {
    MD: [2, 3, 4], // Subordinate-lien mortgages
    VT: [1], // First-lien mortgages
};
